<script lang="ts">
  import type { CinemaSponsoredProduct } from "../../types/CinemaProductsDto.types";

  const { variations }: { variations: CinemaSponsoredProduct[] } = $props();
  /*                                                                                                   */
  let sheetElement: any = $state();

  export function open() {
    if (sheetElement) {
      sheetElement.open = true;
    }
  }
</script>

<!-- render oc-sheet-v1 component and assign the dom-instance to sheetElement -->
<oc-sheet-v1
  bind:this={sheetElement}
  class="spa-oc-sheet"
  headline="Warum sehe ich diese Fläche?"
>
  <div>
    <div class="dsa-section">
      <p class="oc-copy-100">
        Hier handelt es sich um eine gesponserte Fläche. Das sind Werbeanzeigen,
        die von unseren Lieferanten und Händlern finanziert werden.
      </p>
      <p class="oc-copy-100">
        Wir achten darauf, dass diese Anzeigen zu deinem Interesse bzw. deiner
        Suche passen.
      </p>
    </div>
    <div class="dsa-section">
      <h2 class="oc-headline-100">Über die Werbetreibenden</h2>
      {#each variations as variation}
        <div class="dsa-ad">
          <div class="dsa-ad-image">
            <img
              src={`${variation.image.url}?$tile_square$`}
              alt={variation.image.alt}
            />
          </div>
          <ul>
            <li>
              <span class="oc-headline-50">Name des Werbetreibenden:</span>
              <br />
              <span class="oc-copy-100"
                >{variation.legalInfo.advertiserLegalName}</span
              >
            </li>
            <li>
              <span class="oc-headline-50">Wer hat diese Anzeige bezahlt:</span>
              <br />
              <span class="oc-copy-100"
                >{variation.legalInfo.payerLegalName}</span
              >
            </li>
          </ul>
        </div>
      {/each}
    </div>
  </div>
</oc-sheet-v1>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .dsa-section {
    margin-bottom: tokens.$oc-semantic-spacing-150;
    user-select: text;
  }

  .dsa-ad {
    display: flex;
    align-items: flex-start;
    gap: tokens.$oc-semantic-spacing-75;
    margin-top: tokens.$oc-semantic-spacing-75;
  }

  .dsa-ad-image img {
    width: 60px;
    height: 60px;
    object-fit: contain;
  }

  .dsa-ad ul {
    list-style: disc;
    padding: 0 0 0 tokens.$oc-semantic-spacing-100;
    margin: 0;
  }

  .dsa-ad li {
    margin-bottom: tokens.$oc-semantic-spacing-25;
  }
</style>
